import { TableRow, TableCell } from '@mui/material';
import { Link } from 'react-router-dom';
import dateFormatter from '../../../formatters/dateFormatter';

const TicketsListItem = props => {
  return (
    <TableRow>
      <TableCell><Link to={props._id}>{props._id}</Link></TableCell>
      <TableCell>{props.subject}</TableCell>
      <TableCell>{props.userRef?.name}</TableCell>
      <TableCell>{dateFormatter(props.createdAt ?? null)}</TableCell>
    </TableRow>
  );
}

export default TicketsListItem;
